export default [
{
  _name: 'CSidebarNav',
  _children: [
    {
      _name: 'CSidebarNavItem',
      name: '상황판',
      to: '/dashboard_',
      icon: 'cil-chart-line'
    },
    {
      _name: 'CSidebarNavItem',
      name: '사용자 관리',
      to: '/users',
      icon: 'cil-user',
    },
    {
      _name: 'CSidebarNavItem',
      name: '사이트 관리',
      to: '/sites',
      icon: 'cil-sitemap',
    },
    {
      _name: 'CSidebarNavItem',
      name: '이벤트 관리',
      to: '/events',
      icon: 'cib-redis',
    }
  ]
}
]